import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
import { Typography } from './util';
import { ContentTag } from './util/Element';
const useStyles = makeStyles(() => ({
    root: {
        display: 'block',
    },
}));
const Label = (props) => {
    const classes = useStyles();
    return (React.createElement(Typography, { ...props, className: classNames(classes.root, props.className), type: ContentTag.LABEL }));
};
export default Label;
//# sourceMappingURL=Label.js.map